import { useCallback } from 'react'
import { useIntl } from 'react-intl'

const useText = () => {
    const intl = useIntl()
    const text = useCallback(
        (id: string, values?: Record<string, any>): string => {
            return intl.formatMessage({ id }, values) ?? id
        },
        [intl]
    )
    return text
}
export default useText
